export enum BankingDepositStatusEnum {
  ALL = 'ALL',
  REDEEMED = 'REDEEMED',
  OUTSTANDING = 'OUTSTANDING',
  DELETED = 'DELETED'
}